(function () {
  const SCOPE_SELECTOR = '[data-school-referral-form]';
  const EMBED_SELECTOR = 'shopify-forms-embed, form-embed, [data-forms-id]';
  const FIELD_SELECTOR = '[class*="formField"]';
  const PATCHED_ATTR = 'data-st-srf-patched';
  const MAX_PATCH_ATTEMPTS = 20;

  function hideHoneypotTextarea(textarea) {
    if (!textarea || textarea.hasAttribute('data-st-srf-hidden')) return;

    textarea.setAttribute('data-st-srf-hidden', '');
    textarea.style.display = 'none';

    const field = textarea.closest(FIELD_SELECTOR);
    if (!field || field.hasAttribute('data-st-srf-hidden')) return;

    const visibleControls = [...field.querySelectorAll('input, textarea, select')].filter(
      (control) => control !== textarea && !control.hasAttribute('data-st-srf-hidden')
    );

    if (visibleControls.length === 0) {
      field.setAttribute('data-st-srf-hidden', '');
      field.style.display = 'none';
    }
  }

  function hideHoneypots(root) {
    const submitButton = root.querySelector(
      'button[type="submit"], [class*="formSubmitButton"], [class*="submitButton"]'
    );

    root.querySelectorAll('textarea').forEach((textarea) => {
      const meta = [textarea.name, textarea.id, textarea.className, textarea.getAttribute('autocomplete')]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      if (textarea.tabIndex === -1) {
        hideHoneypotTextarea(textarea);
        return;
      }

      if (textarea.getAttribute('aria-hidden') === 'true') {
        hideHoneypotTextarea(textarea);
        return;
      }

      if (/captcha|honeypot|botcheck|spam|security/.test(meta)) {
        hideHoneypotTextarea(textarea);
        return;
      }

      if (!submitButton) return;

      const followsSubmit = Boolean(
        submitButton.compareDocumentPosition(textarea) & Node.DOCUMENT_POSITION_FOLLOWING
      );

      if (!followsSubmit) return;

      const field = textarea.closest(FIELD_SELECTOR);
      const label = field && field.querySelector('label, [class*="fieldLabel"], [class*="formLabel"]');
      const labelText = label && label.textContent ? label.textContent.trim() : '';

      if (!labelText) {
        hideHoneypotTextarea(textarea);
      }
    });
  }

  function copyScopeVars(host, scope) {
    const scopeVars = getComputedStyle(scope);
    [
      '--st-srf-text',
      '--st-srf-input-bg',
      '--st-srf-input-border',
      '--st-srf-input-focus-border',
      '--st-srf-input-radius',
      '--st-srf-button-bg',
      '--st-srf-button-text',
      '--st-srf-button-hover-bg',
      '--st-srf-button-radius',
      '--st-srf-required',
      '--st-srf-success-bg',
      '--st-srf-success-text',
      '--st-srf-error-bg',
      '--st-srf-error-text'
    ].forEach((name) => {
      host.style.setProperty(name, scopeVars.getPropertyValue(name).trim());
    });
  }

  function patchEmbed(host, scope) {
    if (host.hasAttribute(PATCHED_ATTR)) return true;

    const root = host.shadowRoot;
    if (!root || !root.querySelector('form, input, textarea, button')) return false;

    copyScopeVars(host, scope);
    hideHoneypots(root);
    host.setAttribute(PATCHED_ATTR, '');
    return true;
  }

  function tryPatchScope(scope, attempt) {
    const hosts = scope.querySelectorAll(EMBED_SELECTOR);
    let needsRetry = false;

    hosts.forEach((host) => {
      if (!patchEmbed(host, scope)) {
        needsRetry = true;
      }
    });

    if (needsRetry && attempt < MAX_PATCH_ATTEMPTS) {
      window.setTimeout(() => tryPatchScope(scope, attempt + 1), 150);
    }
  }

  function initScope(scope) {
    if (scope.hasAttribute('data-school-referral-form-initialized')) return;
    scope.setAttribute('data-school-referral-form-initialized', '');
    tryPatchScope(scope, 0);
  }

  document.querySelectorAll(SCOPE_SELECTOR).forEach(initScope);
})();
